import styled, { css } from 'styled-components';
import { Button as MuiButton } from '@mui/material';
import { palette } from '@innovyze/stylovyze/lib/utils/styles';
export const Button = styled(MuiButton) `
	&& {
		${({ palettekey, variant }) => palettekey &&
    (variant === 'contained'
        ? css `
						background: ${palette[palettekey].dark};
						color: #fff;
						&:hover {
							background: ${palette[palettekey].dark};
						}
						&:disabled {
							background: ${palette[palettekey].dark};
							color: #fff;
							opacity: 0.5;
						}
				  `
        : css `
						color: ${palette[palettekey].dark};
						border-color: ${palette[palettekey].dark};
						&:hover {
							background: ${palette[palettekey].dark}40;
						}
						&:disabled {
							color: ${palette[palettekey].dark}50;
							border-color: ${palette[palettekey].dark}50;
						}
				  `)};
	}
`;
